module.exports = __webpack_public_path__ + "img/qp.2c859fe0.png";